var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.3333V9.16667C5.5 7.70798 6.07946 6.30903 7.11091 5.27758C8.14236 4.24613 9.54131 3.66667 11 3.66667C12.4587 3.66667 13.8576 4.24613 14.8891 5.27758C15.9205 6.30903 16.5 7.70798 16.5 9.16667V18.3333M1.83333 12.4346C1.83333 10.5527 3.66667 10.0833 5.5 10.0833V18.3333C4.52754 18.3333 3.59491 17.947 2.90727 17.2594C2.21964 16.5718 1.83333 15.6391 1.83333 14.6667V12.4346ZM20.1667 12.4346C20.1667 10.5527 18.3333 10.0833 16.5 10.0833V18.3333C17.4725 18.3333 18.4051 17.947 19.0927 17.2594C19.7804 16.5718 20.1667 15.6391 20.1667 14.6667V12.4346Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.2b974202fb5db5e06986330700e8cdb6.svg";
export { ForwardRef as ReactComponent };